import { BaseDto } from './base.dto';
export class OrderSerialDto extends BaseDto{
    serialId?: number;
    orderId?: number;
    merchantId?: number;
    
}